export default __webpack_public_path__ + "static/media/5.141a7329.png";